export default __webpack_public_path__ + "static/media/page_logo.bf6785f0.png";